import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarGrupoContaBanco, setModalDeletarGrupoContaBanco } from "../redux/slices/grupoContaBanco/grupoContaBancoSlice";
import { sincronizarAgrupamentoContaBanco } from "./agrupamentoContaBancoService";

export const cadastrarGrupoContaBanco = createAsyncThunk("/GrupoContaBanco/CadastrarGrupoContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post("/GrupoContaBanco/CadastrarGrupoContaBanco", payload.value);
    const idCriado = response.data?.data?.id ?? response.data?.id;

    if (idCriado && payload.listaIdContaBanco?.length > 0) {
      await dispatch(
        sincronizarAgrupamentoContaBanco({
          idGrupoContaBanco: idCriado,
          listaIdContaBanco: payload.listaIdContaBanco,
        })
      );
    }

    toastSucess("Grupo de conta bancária cadastrado com sucesso");
    dispatch(setModalCadastrarGrupoContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarGrupoContaBanco = createAsyncThunk("/GrupoContaBanco/BuscarGrupoContaBanco", async (args: { pesquisar?: string | null; id?: number | null } | void) => {
  try {
    const data = await api.get("/GrupoContaBanco/BuscarGrupoContaBanco", {
      params: args || {},
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarGrupoContaBanco = createAsyncThunk("/GrupoContaBanco/AtualizarGrupoContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/GrupoContaBanco/AtualizarGrupoContaBanco", payload.value);
    toastSucess("Grupo de conta bancária atualizado com sucesso");
    dispatch(setModalCadastrarGrupoContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarGrupoContaBanco = createAsyncThunk("/GrupoContaBanco/DeletarGrupoContaBanco", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/GrupoContaBanco/DeletarGrupoContaBanco", { params: { id: payload.value } });
    toastSucess("Grupo de conta bancária removido com sucesso");
    dispatch(setModalDeletarGrupoContaBanco(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoContaBanco(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
